<script setup>
import { onMounted } from 'vue';
import Nav from './components/nav.vue';
import MasterSection from './components/MasterSection.vue';
import HallSection from './components/HallSection.vue';
import ServiceList from './components/ServiceList.vue';
import ServiceCaseSection from './components/ServiceCaseSection.vue';
import FeedbackSection from './components/FeedbackSection.vue';
import ContactSection from './components/ContactSection.vue';
import Footer from './components/Footer.vue';
import mTopImg from '../../../assets/images/m-top.png';
import { logEvent } from '@/utils/firebase.js';

onMounted(() => {
  // 页面浏览埋点
  logEvent('mobile_fengsui_uv');
  logEvent('mobile_fengsui_pv');
});
</script>

<template>
  <div class="mobile-home">
    <Nav />
    <!-- 移动端头图 -->
    <section class="hero-section">
      <img
        :src="mTopImg"
        alt="楓燧堂服务介绍"
        class="hero-image"
      />
      <a
        href="https://diversion.salesmartly.com/split/whatsapp/fi8cxf"
        target="_blank"
        rel="noopener noreferrer"
        class="cta-button"
      >
        即刻獲取運勢分析
      </a>
    </section>
    <!-- 移动端内容 -->
    <div id="1">
      <MasterSection />
    </div>
    <HallSection />
    <div id="2">
      <ServiceList />
    </div>
    <div id="3">
      <FeedbackSection />
    </div>
    <div id="4">
      <ServiceCaseSection />
    </div>
    <div id="5">
      <ContactSection />
    </div>
    <Footer />
  </div>
</template>

<style scoped lang="scss">
.mobile-home {
  width: 100%;
}

.hero-section {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.hero-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.cta-button {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  display: inline-block;
  padding: 0.3rem 2.5rem;
  background: linear-gradient(135deg, #e5ad3e 0%, #d4af37 100%);
  color: #000000;
  font-size: 0.5rem;
  //   font-weight: 600;
  text-decoration: none;
  border-radius: 1rem;
  box-shadow: 0 0.08rem 0.3rem rgba(229, 173, 62, 0.4);
  transition: all 0.3s ease;
  white-space: nowrap;
  z-index: 10;

  //   &:hover {
  //     background: linear-gradient(135deg, #d4af37 0%, #c49f2f 100%);
  //     box-shadow: 0 0.12rem 0.4rem rgba(229, 173, 62, 0.6);
  //     transform: translateX(-50%) translateY(-0.04rem);
  //   }

  //   &:active {
  //     transform: translateX(-50%) translateY(0);
  //   }
}
</style>
